export default __webpack_public_path__ + "static/media/expenses2.827808d7.png";